// WeatherWidget.js
import React, { useState, useEffect } from 'react';
import {
      CCol,
      CRow,
      CButton,
      CModal,
      CModalHeader,
      CModalBody,
      CModalFooter,
      CCard,
      CCardBody,
      CCardHeader,
} from '@coreui/react';
import axios from 'axios';

const WeatherWidget = () => {
      const [weatherData, setWeatherData] = useState(null);
      const [modal, setModal] = useState(false);
      const [locationAllowed, setLocationAllowed] = useState(true);
      const [loading, setLoading] = useState(false);
      const [coords, setCoords] = useState(null);

      const toggleModal = () => setModal(!modal);

      useEffect(() => {
            if (locationAllowed) {
                  setLoading(true);
                  navigator.geolocation.getCurrentPosition(
                        (position) => {
                              const { latitude, longitude } = position.coords;
                              setCoords({ latitude, longitude });
                              fetchWeatherData(latitude, longitude);
                        },
                        (error) => {
                              console.error('Error getting location:', error);
                              setLoading(false);
                        }
                  );
            }
      }, [locationAllowed]);

      const fetchWeatherData = async (lat, lon) => {
            const apiKey = import.meta.env.VITE_OPENWEATHER_API_KEY;
            try {
                  const response = await axios.get(
                        `https://api.openweathermap.org/data/2.5/weather`,
                        {
                              params: {
                                    lat,
                                    lon,
                                    units: 'imperial', // 'metric' for Celsius, 'imperial' for Fahrenheit
                                    appid: apiKey,
                              },
                        }
                  );
                  setWeatherData(response.data);
            } catch (error) {
                  console.error('Error fetching weather data:', error);
            } finally {
                  setLoading(false);
            }
      };

      const handleAllowLocation = () => {
            setLocationAllowed(true);
      };

      return (
            <CCard style={{ padding: '20px', margin: '20px' }}>
                  <CCardHeader>
                        <h4>Current Weather</h4>
                  </CCardHeader>
                  <CCardBody>
                        {weatherData ? (
                              <div style={{ textAlign: 'center' }}>
                                    <h6>{weatherData.name}</h6>
                                    <p style={{ textTransform: 'capitalize', fontSize: '1.2em' }}>
                                          {weatherData.weather[0].description}
                                    </p>
                                    <p style={{ fontSize: '2em', margin: 0 }}>
                                          {Math.round(weatherData.main.temp)}°C
                                    </p>
                              </div>
                        ) : (
                              <div style={{ textAlign: 'center' }}>
                                    {!locationAllowed ? (
                                          <CButton color="success" size="sm" onClick={handleAllowLocation}>
                                                Allow Location
                                          </CButton>
                                    ) : loading ? (
                                          <p>Loading weather data...</p>
                                    ) : (
                                          <p>Unable to retrieve weather data.</p>
                                    )}
                              </div>
                        )}
                  </CCardBody>
                  <CCardBody>
                        <CRow className="justify-content-center">
                              <CCol xs="auto">
                                    <CButton
                                          color="info"
                                          size="sm"
                                          onClick={toggleModal}
                                          disabled={!coords}
                                          style={{ margin: '5px' }}
                                    >
                                          View Doppler Radar
                                    </CButton>
                              </CCol>
                        </CRow>
                  </CCardBody>

                  <CModal visible={modal} onClose={() => setModal(false)} size="lg">
                        <CModalHeader closeButton>Doppler Radar</CModalHeader>
                        <CModalBody>
                              {coords ? (
                                    <iframe
                                          src={`https://embed.windy.com/embed2.html?lat=${coords.latitude}&lon=${coords.longitude}&detailLat=${coords.latitude}&detailLon=${coords.longitude}&width=650&height=450&zoom=5&level=surface&overlay=radar&product=ecmwf&menu=&message=true&marker=&calendar=&pressure=&type=map&location=coordinates&detail=&metricWind=default&metricTemp=default&radarRange=-1`}
                                          width="100%"
                                          height="500px"
                                          frameBorder="0"
                                          title="Doppler Radar"
                                    ></iframe>
                              ) : (
                                    <p>Loading radar map...</p>
                              )}
                        </CModalBody>
                        <CModalFooter>
                              <CButton color="danger" size="lg" onClick={toggleModal}>
                                    Close
                              </CButton>
                        </CModalFooter>
                  </CModal>
            </CCard>
      );
};

export default WeatherWidget;
